import { WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import type { WorkflowRule } from '../types';

// Guard: bootstrap (dealership fetch) failed — show global error immediately
export const bootstrapErrorRule: WorkflowRule = (state: any): WorkflowStatus | null => {
    const requestStatus = state?.salesCheckin?.dealerships?.requestStatus;
    return requestStatus === ApiRequestStatus.Error ? WorkflowStatus.BOOTSTRAP_ERROR : null;
};
